import React from 'react';

const SIZES = {
    xs: { box: 20, text: 'text-[9px]' },
    sm: { box: 24, text: 'text-[10px]' },
    md: { box: 30, text: 'text-[11px]' },
    lg: { box: 38, text: 'text-label' },
    xl: { box: 56, text: 'text-lg' },
};

const initials = (name = '') =>
    String(name)
        .trim()
        .split(/\s+/)
        .slice(0, 2)
        .map((p) => p[0])
        .join('')
        .toUpperCase() || '?';

/** Deterministic tint so the same person keeps the same colour everywhere. */
const TINTS = [
    'bg-primary-50 text-primary-600',
    'bg-secondary-50 text-secondary-700',
    'bg-success-subtle text-success-strong',
    'bg-warning-subtle text-warning-strong',
    'bg-ink-100 text-ink-700',
];

const tintFor = (name = '') => {
    let hash = 0;
    for (let i = 0; i < name.length; i += 1) hash = (hash * 31 + name.charCodeAt(i)) % 997;
    return TINTS[hash % TINTS.length];
};

const Avatar = ({ name, size = 'md', className = '', title, ring = false }) => {
    const { box, text } = SIZES[size] || SIZES.md;
    return (
        <span
            title={title || name}
            aria-label={name}
            className={`inline-flex items-center justify-center rounded-full font-semibold shrink-0 ${text} ${tintFor(
                name || ''
            )} ${ring ? 'ring-2 ring-white' : ''} ${className}`}
            style={{ width: box, height: box }}
        >
            {initials(name)}
        </span>
    );
};

export const AvatarGroup = ({ names = [], max = 3, size = 'sm' }) => {
    const shown = names.slice(0, max);
    const rest = names.length - shown.length;
    const { box, text } = SIZES[size] || SIZES.sm;
    return (
        <div className="flex -space-x-1.5">
            {shown.map((n, i) => (
                <Avatar key={`${n}-${i}`} name={n} size={size} ring />
            ))}
            {rest > 0 && (
                <span
                    className={`inline-flex items-center justify-center rounded-full bg-ink-100 text-ink-600 font-semibold ring-2 ring-white ${text}`}
                    style={{ width: box, height: box }}
                    title={names.slice(max).join(', ')}
                >
                    +{rest}
                </span>
            )}
        </div>
    );
};

export default Avatar;
